module.exports = __webpack_public_path__ + "img/38.15806afd.jpg";